import { h } from 'preact';
import React, { useContext } from 'react';
import domPurify from 'dompurify';

import { PreloadContext } from '../../contexts';

/** Use this with dangerouslySetInnerHTML to sanitize HTML when appropriate */
export const Sanitize = ({ html }) => {
  return domPurify.sanitize(html, { ADD_ATTR: ['target'] });
}